//import compact from 'lodash/compact';
//import each from 'lodash/each';
//import filter from 'lodash/filter';
//import groupBy from 'lodash/groupBy';
import isNumber from 'lodash/isNumber';
//import keys from 'lodash/keys';
//import map from 'lodash/map';
//import mapValues from 'lodash/mapValues';
//import max from 'lodash/max';
import range from 'lodash/range';
//import reduce from 'lodash/reduce';
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';
//import sortBy from 'lodash/sortBy';
//import sortedUniq from 'lodash/sortedUniq';
//import sumBy from 'lodash/sumBy';
import toInteger from 'lodash/toInteger';

export default {
//  compact,
//  each,
//  filter,
//  groupBy,
  isNumber,
//  keys,
//  map,
//  mapValues,
//  max,
  range,
//  reduce,
  shuffle,
  slice,
//  sortBy,
//  sortedUniq,
//  sumBy,
  toInteger,
};



// WEBPACK FOOTER //
// ./src/mylodash.js